import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';

import Lock from '@material-ui/icons/Lock';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { useTranslation } from 'react-i18next';

import SelectCustom from './library/select';
import {validate0} from './validate';
import ButtonValidation from './button_validation';

const displayedYears = 3;

const optionsYears = [];

const currentYear = new Date().getFullYear();

for(var i = 1; i < displayedYears + 1; i++)
{
	var year = currentYear - i;
	optionsYears.push({ value: year, label: year.toString()});
}

const optionsCurrency = [
  { value: 'EUR', label: 'EUR' },
  { value: 'CHF', label: 'CHF' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'MAD', label: 'MAD' },
  { value: 'TND', label: 'TND' }
];


const Select = (props) => (
  <SelectCustom {...props} />
);

const styles  = theme => ({
  title: {
    fontWeight:'bold', 
    marginBottom: theme.spacing.unit
  },
  subtitle:{
    fontWeight:'bold'

  },
  avatar:{
  	backgroundColor: theme.palette.primary.main,
  	color: theme.palette.common.white,
  },
  divider:{
  	margin:'auto',
  	marginTop: 2*theme.spacing.unit,
  	marginBottom: 2*theme.spacing.unit,
  	width:100,

  }
 });

function FormEstimation1 (props) {
	const { t } = useTranslation();
	
	const { handleSubmit, classes } = props;		 
	return (
		<form onSubmit={handleSubmit}>
			<Typography variant="h5" className={classes.title}>{t("title")}</Typography>
			<ListItem >
				<ListItemIcon className={classes.subtitleIcon}>
				<Avatar className={classes.avatar}>
					<Lock/>
					</Avatar>
				</ListItemIcon>
				<ListItemText >
				<Typography variant="h6" className={classes.subtitle}>
					{t("content")}
					</Typography>
					<Typography >{t("sub_content")}</Typography>
				</ListItemText>
			</ListItem>
			
			<Divider className={classes.divider} />
			{/*Should understand Field and  */}

			<Grid container spacing={8}>
				<Grid item xs={12}>
					<Field 
						label={t('currency_label')}
						name="currency"
						placeholder={t('selection_placeholder')}
						options={optionsCurrency}
						component={Select}
						/>
				</Grid>
				<Grid item xs={12}>
					<Field
						label={t('year_label')}
						name='latestYear'
						placeholder={t('selection_placeholder')}
						options={optionsYears}
						component={Select}
					/>
				</Grid>
				<Grid item xs={12}>
					<ButtonValidation 
						activeStep = {props.activeStep}
						handleBack = {props.handleBack} 
						steps  = {props.steps} 
						invalid = {props.invalid}
					/>
				</Grid>
			</Grid>
		</form> 
	);
}


FormEstimation1.propTypes = {
  classes: PropTypes.object.isRequired,
};

FormEstimation1 = withStyles(styles)(FormEstimation1);


FormEstimation1 = reduxForm({ 
	form: 'formEstimation',
	destroyOnUnmount: false, // <------ preserve form data
	forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
	validate: validate0
})(FormEstimation1);

export default FormEstimation1;
